class ModernDetails {
	constructor(details, summary, contentWrapper) {
		this.details = details;
		this.summary = summary;
		this.contentWrapper = contentWrapper;
		this.isAnimating = false;

		this.init();
	}

	init() {
		this.summary.addEventListener('click', (e) => this.handleClick(e));
	}

	handleClick(e) {
		const isOpening = !this.details.open;
		e.preventDefault();
		if (this.isAnimating) {
			return;
		}

		if (!isOpening) {
			this.isAnimating = true;

			this.contentWrapper.style.height = 'auto';

			requestAnimationFrame(() => {
				this.contentWrapper.style.height = '0px';

				setTimeout(() => {
					this.details.removeAttribute('open');
					this.isAnimating = false;
				}, 300);
			});
		} else {
			this.isAnimating = true;

			this.contentWrapper.style.height = '0px';
			this.details.setAttribute('open', '');

			requestAnimationFrame(() => {
				this.contentWrapper.style.height = 'auto';

				setTimeout(() => {
					this.isAnimating = false;
				}, 300);
			});
		}
	}
}

class LegacyDetails {
	constructor(details, summary, contentWrapper) {
		this.details = details;
		this.summary = summary;
		this.contentWrapper = contentWrapper;
		this.isAnimating = false;
		this.heightCache = new Map();

		this.init();
	}

	init() {
		if (!this.details.open) {
			this.contentWrapper.style.height = '0px';
		}

		this.summary.addEventListener('mouseenter', () =>
			this.preCalculateHeight()
		);
		this.summary.addEventListener('focus', () => this.preCalculateHeight());
		this.summary.addEventListener('click', (e) => this.handleClick(e));
		this.summary.addEventListener('keydown', (e) => this.handleKeydown(e));

		this.initObserver();

		let resizeTimeout;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				this.heightCache.clear();
			}, 250);
		});
	}

	preCalculateHeight() {
		if (this.details.open || this.heightCache.has(this.details)) {
			return;
		}

		const wasOpen = this.details.open;
		const originalVisibility = this.details.style.visibility;

		this.details.style.visibility = 'hidden';
		this.details.open = true;

		this.contentWrapper.style.height = 'auto';
		const naturalHeight = this.contentWrapper.offsetHeight;

		this.contentWrapper.style.height = wasOpen ? 'auto' : '0px';
		this.details.open = wasOpen;
		this.details.style.visibility = originalVisibility;

		this.heightCache.set(this.details, naturalHeight);
	}

	handleClick(e) {
		e.preventDefault();

		if (this.isAnimating) {
			return;
		}

		const isOpening = !this.details.open;

		if (isOpening) {
			this.open();
		} else {
			this.close();
		}
	}

	open() {
		this.isAnimating = true;
		this.details.open = true;

		const cachedHeight = this.heightCache.get(this.details);

		if (cachedHeight) {
			this.contentWrapper.style.height = '0px';
			requestAnimationFrame(() => {
				this.contentWrapper.style.height = cachedHeight + 'px';
				this.finishAnimation(true);
			});
		} else {
			this.contentWrapper.style.height = 'auto';
			const naturalHeight = this.contentWrapper.offsetHeight;
			this.contentWrapper.style.height = '0px';

			// Force reflow
			// eslint-disable-next-line no-unused-expressions
			this.contentWrapper.offsetHeight;

			this.contentWrapper.style.height = naturalHeight + 'px';
			this.heightCache.set(this.details, naturalHeight);
			this.finishAnimation(true);
		}
	}

	close() {
		this.isAnimating = true;
		const currentHeight = this.contentWrapper.offsetHeight;
		this.contentWrapper.style.height = currentHeight + 'px';

		// Force reflow
		// eslint-disable-next-line no-unused-expressions
		this.contentWrapper.offsetHeight;

		this.contentWrapper.style.height = '0px';
		this.finishAnimation(false);
	}

	finishAnimation(isOpen) {
		setTimeout(() => {
			if (isOpen && this.details.open) {
				this.contentWrapper.style.height = 'auto';
			} else if (!isOpen) {
				this.details.open = false;
			}
			this.isAnimating = false;
		}, 200);
	}

	handleKeydown(e) {
		if (e.key === 'Enter' || e.key === ' ') {
			setTimeout(() => this.summary.click(), 0);
		}
	}

	initObserver() {
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (
					mutation.type === 'attributes' &&
					mutation.attributeName === 'open'
				) {
					if (!this.isAnimating) {
						this.contentWrapper.style.height = this.details.open
							? 'auto'
							: '0px';
					}
				}
			});
		});

		observer.observe(this.details, {
			attributes: true,
			attributeFilter: ['open'],
		});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const supportsModernAnimations =
		CSS.supports('interpolate-size', 'allow-keywords') &&
		CSS.supports('transition-behavior', 'allow-discrete');

	const specialtyDetailsElements = document.querySelectorAll(
		'.wp-block-improntad-theme-blocks-specialty-catalog .procedures details'
	);
	console.log('🚀 ~ specialtyDetailsElements:', specialtyDetailsElements);

	specialtyDetailsElements.forEach((details) => {
		const summary = details.querySelector('.procedure-summary');
		const contentWrapper = details.querySelector(
			'.procedure-content-wrapper'
		);

		if (!details || !summary || !contentWrapper) {
			return;
		}

		details.classList.add(
			supportsModernAnimations
				? 'has-modern-animations'
				: 'has-fallback-animations'
		);

		if (supportsModernAnimations) {
			new ModernDetails(details, summary, contentWrapper);
		} else {
			new LegacyDetails(details, summary, contentWrapper);
		}
	});

	const handleTabClick = (clickedButton) => {
		const specialtyId = clickedButton.dataset.specialtyId;
		const panelId = clickedButton.getAttribute('aria-controls');
		const catalog = clickedButton.closest('.specialty-catalog');

		const allButtons = catalog.querySelectorAll('.specialty-button');
		allButtons.forEach((btn) => {
			const isActive = btn.dataset.specialtyId === specialtyId;
			btn.classList.toggle('active', isActive);
			btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
		});

		const allPanels = catalog.querySelectorAll('.procedures');
		allPanels.forEach((panel) => {
			const shouldShow = panel.id === panelId;
			panel.classList.toggle('active', shouldShow);
			if (shouldShow) {
				panel.removeAttribute('hidden');
			} else {
				panel.setAttribute('hidden', '');
			}
		});
	};

	const specialtyButtons = document.querySelectorAll(
		'.specialty-catalog .specialty-button'
	);
	specialtyButtons.forEach((button) => {
		button.addEventListener('click', () => handleTabClick(button));
	});

	// const activeProcedure = document.querySelector(
	// 	'.specialty-catalog .procedure.active'
	// );
	// const activeSpecialty = document.querySelector(
	// 	'.specialty-catalog .specialty-button.active'
	// );

	// const prefersReducedMotion = window.matchMedia(
	// 	'(prefers-reduced-motion: reduce)'
	// ).matches;

	// if (activeSpecialty) {
	// 	setTimeout(() => {
	// 		activeSpecialty.scrollIntoView({
	// 			behavior: prefersReducedMotion ? 'auto' : 'smooth',
	// 			inline: 'end',
	// 			block: 'end',
	// 		});
	// 	}, 300);
	// }

	// if (activeProcedure) {
	// 	setTimeout(() => {
	// 		activeProcedure.scrollIntoView({
	// 			behavior: prefersReducedMotion ? 'auto' : 'smooth',
	// 			inline: 'end',
	// 			block: 'end',
	// 		});
	// 	}, 300);
	// }
});
